import React, { createRef } from "react";
import {
  Form,
  Input,
  Select,
  Checkbox,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  message,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import dayjs from "dayjs";
import withRouter from "../withRouter";
import SpeedViolationReportStore from "../store/SpeedViolationReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";

import L from "leaflet";

import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import MapForVehiclePosition from "./MapForVehiclePosition";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PythonMessageAlert from "./PythonMessageAlert";

const { RangePicker } = DatePicker;
const { Option } = Select;

class SpeedViolationReportList extends React.Component {
  formRef = React.createRef();
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.speedReportStore = new SpeedViolationReportStore();
    this.vehicleStore = new VehicleStore();
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      companyId: "",
      modalVisible: false,
      column: "",
      filter: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      showMap: false,
      showMonthPopup: false,
      showAlertPopup: false,
      modalInfoObj: "",
      Notcompany: false,
      Notasset: false,
      Notspeed: false,
      vehicleObj: false,
      selectAllVehicles: false,
      showEmailModal: false,
      Notdate: false,
      reportmessage: "",
      selectedColumns: [
        {
          // title: "Vehicle No ",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          ellipsis: {
            showTitle: true,
          },

          //   fixed: 'left',
          //   width:'15%'
        },
        {
          // title: "  Driver",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_DRIVER_"),
          dataIndex: "name",
          key: "name",
          ellipsis: {
            showTitle: true,
          },

          // width:'15%'
        },
        {
          // title: "Speed ",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_SPEED_"),
          dataIndex: "speed",
          key: "speed",
          ellipsis: {
            showTitle: true,
          },

          //fixed: 'left',
          //   width:'15%'
        },

        {
          // title: " Location ",
          title: context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
          dataIndex: "location",
          key: "location",
          ellipsis: {
            showTitle: true,
          },
          // width:'15%'
        },
        {
          // title: " Time  ",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_TIME_"),
          dataIndex: "timestamp_str",
          key: "timestamp_str",

          // width:'15%'
        },
        {
          // title: " View On Map",
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          dataIndex: "view",
          key: "view",
          render: (value, obj) => {
            return (
              <>
                <Image
                  style={{ cursor: "pointer" }}
                  src={require("../assets/images/mapIcon/gps_icon.png")}
                  width={25}
                  height={25}
                  onClick={async () => {
                    await this.setState({
                      vehicleObj: { ...obj, icon: "map-car-icon-green.png" },
                      heading: this.context.translate(
                        "_SPEED_VIOLATION_REPORT_"
                      ),
                    });
                    await this.setState({ loadData: 1 });
                  }}
                />
                {/* <Link
                  onClick={(e) =>
                    this.setState({
                      modalInfoObj: "",
                      showMap: true,
                      modalInfoObj: obj,
                    })
                  }
                >
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                  />
                </Link> */}
              </>
            );
          },
          // width:'15%'
        },
      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          //  console.log(result.toString())

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            // intervel: this.state.intervel,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            // userId: 1,
            filter: this.state.filter,
            speedlimit: this.state.speedlimit,

            colList: result.toString(),
          };
          if (val.key == "excel") {
            // console.log("afd")
            //this.speedReportStore.exportExcel(getData);
            await this.speedReportStore.exportExcel(getData);
            const isSuccess =
              this.speedReportStore?.pythonReportMessage === true;
            const isError = this.speedReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }

          }
          if (val.key == "pdf") {
            //this.speedReportStore.exportpdf(getData);

            await this.speedReportStore.exportpdf(getData);
            const isSuccess =
              this.speedReportStore?.pythonReportMessage === true;
            const isError = this.speedReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }



          }
          // if (val.key == "csv") {
          //   this.speedReportStore.exportcsv(getData);
          // }
          // if (val.key == "xml") {
          //   this.speedReportStore.exportxml(getData);
          // }
        }
      },
    };

    this.showMenu = {
      items: [
        {
          // label: "Excel",
          label: "Email",
          key: "email",
        },
      ],
      onClick: (val) => {
        if (val.key == "email") {
          this.setState({ showEmailModal: true });
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }
  async componentDidMount() {
    // await this.speedReportStore.loadData({ offset: 0, limit: 50 });

    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.state.vehicleObj !== prevState.vehicleObj) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }
  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({
      companyId: comp?.value,
      currentPage: 1,
      pageSize: 50,
    });
    await this.setState({ selectedVehicles: [] });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.setState({ loadData: 1 });
    // await this.handleSearch();
    //  console.log(data,"sdcd")
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    // console.log(this.vehicleStore.getVehiclesUsingCompanyId)
    // {filteredOptions.map((option, index) => (
    //       <option key={index} value={option}>
    //         {option}
    //       </option>
    //     ))}
    // await this.speedReportStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: this.state.companyId,
    // });
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  vehicleSelect = async (val) => {
    console.log(val);
    await this.setState({ selectedVehicles: val, Notasset: false });
    console.log(this.state.selectedVehicles);
  };

  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (!this.state.speedlimit) {
      this.setState({ Notspeed: true });
    } else {
      this.setState({ Notspeed: false });
    }
    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }
    if (
      this.state.companyId &&
      this.state.selectedVehicles.length > 0 &&
      this.state.speedlimit &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      this.setState({ Notcompany: false, Notasset: false, Notspeed: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.speedReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles.map(Number),
          speedlimit: this.state.speedlimit,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          currentPage: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };

  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  onEmailSend = async (values) => {
    const data = {
      ...values,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      speedlimit: this.state.speedlimit,
      // colList: result
    };

    const response = await this.speedReportStore.sendExcelByEmail(data);

    if (response?.success === "S") {
      message.success(
        "Report will be generated at backend and sent by email in sometime"
      );
      this.setState({ showEmailModal: false });
      this.formRef.current?.resetFields();
    }
  };
  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  allowClear={true}
                  onChange={this.handleChange}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {(this.props.getUserData().isadmin === 1 || this.props.getUserData().isadmin === 0) && (
                  <DeviceGroupsForVehicles
                    vehicleStore={this.vehicleStore}
                    setLoadDta={() => this.setState({ loadData: 1 })}
                    resetVehicles={() =>
                      this.setState({
                        selectedVehicles: [],
                        selectAllVehicles: false,
                      })
                    }
                  />
                )}
                <Checkbox
                  checked={this.state.selectAllVehicles}
                  onChange={async (e) => {
                    await this.setState({
                      selectAllVehicles: e.target.checked,
                      showAlertPopup: e.target.checked,
                    });
                    // console.log(e.target.checked);
                    await this.handleAllSelectVehicles();
                  }}
                />
                {this.context.translate("_ALL_")}

                <Select
                  className="searchInput"
                  maxTagCount="responsive"
                  value={this.state.selectedVehicles}
                  onChange={(val) => {
                    console.log(val.length);
                    this.setState({ selectedVehicles: val });
                    if (
                      this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                      val.length
                    ) {
                      this.setState({ selectAllVehicles: false });
                    } else {
                      this.setState({ selectAllVehicles: true });
                    }

                    // if (val?.length > 1) {
                    //   console.log(val?.length > 1);
                    //   this.setState({ showAlertPopup: true });
                    // }
                  }}
                  // onSelect={(val)=>{
                  //   console.log(val?.length)

                  // }}
                  style={{ width: 150 }}
                  showSearch
                  status={this.state.Notasset ? "error" : false}
                  mode="multiple"
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                    return (
                      <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                    );
                  })}
                </Select>

                <RangePicker
                  placeholder={["From Datetime", "To Datetime"]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  status={this.state.Notdate ? "error" : false}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                />
                <Input
                  style={{ width: 150, borderRadius: "25px" }}
                  status={this.state.Notspeed ? "error" : false}
                  // placeholder="Speed(Km)"
                  placeholder={this.context.translate("_SPEED_KM_")}
                  value={this.state.speedlimit}
                  onChange={(e) =>
                    this.setState({
                      speedlimit: e.target.value,
                      Notspeed: false,
                    })
                  }
                />
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                    this.setState({ currentPage: 1, pageSize: 50 });
                  }}
                // disabled={
                //   this.state.showAlertPopup ||
                //   this.state.selectAllVehicles ||
                //   this.state.selectedVehicles?.length > 1
                //     ? true
                //     : false
                // }
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.speedReportStore?.speedViolationStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.speedReportStore?.total}
            columns={this.state.column}
            dataSource={this.speedReportStore?.speedViolationStore}
            loading={this.speedReportStore?.loading}
            onChange={this.handleTableChange}
          // pagination={{
          //   pageSize: this.state.pageSize,
          //   total: this.speedReportStore.total || 0,
          // }}
          // scroll={{
          //   // y: this.state.clientHeight-240,
          //   x: 100,
          // }}
          />

          {this.state.vehicleObj && (
            <MapForVehiclePosition
              vehicleObj={this.state.vehicleObj}
              heading={this.state.heading}
              closeMapModal={(resp) => {
                this.setState({ vehicleObj: resp });
              }}
            />
          )}

          {/* {this.state.showMap &&  */}

          {/* <Modal
className="multiTracking-popup"
  //  title="Speed Exception Report"
  title= <div>{this.context.translate("_SPEED_VIOLATION_REPORT_")}<CloseOutlined onClick={() => this.setState({ showMap: false })}/></div>
   open={this.state.showMap}
   centered
   // bodyStyle={{ height: 1000 }}
   width={850}
   height={400}
   onOk={() => this.setState({ showMap: false })}
   onCancel={() => this.setState({ showMap: false })}
   footer={false}
 >
   <MapContainer
     ref={this.mapRef}
     zoom={16}
     center={[
       this.state.modalInfoObj?.latitude,
       this.state.modalInfoObj?.longitude,
     ]}
     style={{ height: "60vh", }}

     // bounds={this.state.modalInfoObj ? [[this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude], [this.state.modalInfoObj.latitude, this.state.modalInfoObj.longitude]] : []}
   >
     <ReactLeafletGoogleLayer />
    

     <Marker
       icon={dotIcon}
       position={[
         this.state.modalInfoObj?.latitude,
         this.state.modalInfoObj?.longitude,
       ]}
     >
       
       <Tooltip permanent={true} direction="top">
         <div
           style={{
             backgroundColor: "#00ff00",
             border: "solid 1px #000",
             textAlign: "center",
             padding: 0,
           }}
         >
           <b>{this.state.modalInfoObj?.vehicleNo}</b>
           <br />
         </div>
       </Tooltip>
     </Marker>
   </MapContainer>
 </Modal>
} */}
          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {/* Alert */}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For Reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
          {console.log(this.state.selectedVehicles?.length)}
          {
            <div>
              <PythonMessageAlert
                ref={this.pythonMessageRef}
                message={this.state.reportmessage}
              />
            </div>
          }


          {/* {(this.state.selectAllVehicles ||
            this.state.selectedVehicles?.length > 1) && (
            <Modal
              width={350}
              className="alert-model"
              title={
                <div>
                  {" "}
                  <i
                    style={{
                      color: "red",
                      fontSize: "18px",
                      marginRight: "5px",
                    }}
                    class="bi bi-exclamation-triangle"
                  ></i>{" "}
               
                  {this.context.translate("_FLEET_ALERT_")}
                </div>
              }
              maskClosable={false}
              open={this.state.showAlertPopup}
              onOk={() => this.setState({ showAlertPopup: false })}
              onCancel={() => this.setState({ showAlertPopup: false })}
              footer={false}
            >
              For all vehicles please select email option from export & report
              will be sent by email.
            </Modal>
          )} */}

          <Modal
            open={this.state.showEmailModal}
            // title="Send Email"
            title={this.context.translate("_SEND_EMAIL_")}
            onOk={() => this.setState({ showEmailModal: false })}
            onCancel={() => this.setState({ showEmailModal: false })}
            footer={false}
            width={400}
          >
            <Form
              ref={this.formRef}
              name="Email"
              layout="vertical"
              onFinish={this.onEmailSend}
              style={{ maxWidth: "100%" }}
            >
              <Form.Item
                name="email"
                // label="Email"
                label={this.context.translate("_FLEET_LOGIN_EMAILLBL_")}
                rules={[{ required: true, type: "email" }]}
              >
                <Input />
              </Form.Item>
              <div className="formBtnGroup">
                {/* css class */}

                <Button
                  type="primary"
                  className="formSaveButton"
                  htmlType="submit"
                // loading={this.state.loading}
                >
                  {/* css class */}
                  Save
                </Button>
              </div>
            </Form>
          </Modal>
        </div>
      </>
    );
  }
}
SpeedViolationReportList.contextType = StoreContext;
export default observer(withRouter(SpeedViolationReportList));
